class ChoicesSelect {
    constructor(el) {
        this.scope = el;
        this.hasSearch = el.hasAttribute("data-search");
        this.hasMultiple = el.hasAttribute("multiple");
        this.selectClasses = (el.getAttribute("data-select-classes") || "").split(/\s+/).filter(Boolean);
        this.dropdownClasses = (el.getAttribute("data-dropdown-classes") || "").split(/\s+/).filter(Boolean);
        const searchAttr = el.getAttribute("data-search-classes");
        this.searchClasses = searchAttr ? searchAttr.split(/\s+/) : [];
        this.hasDelete = el.hasAttribute("data-has-delete");

        this.initialised = false;
        const observer = new MutationObserver((mutationsList, observer) => {
            for (const mutation of mutationsList) {
                for (const node of mutation.addedNodes) {
                    if (node.nodeType === 1 && node.classList.contains('choices')) {
                        observer.disconnect();
                        this.initChoices();
                        return;
                    }
                }
            }
        });

        const isSmall = el.classList.contains("small");
        const isLarge = el.classList.contains("large");
        const sizeClass = isSmall ? "small" : isLarge ? "large" : "regular";

        observer.observe(el.parentNode, { childList: true });
        if(!this.initialised){
            this.choices = new Choices(el, {
                searchEnabled: this.hasSearch,
                itemSelectText: "",
                allowHTML: true,
                classNames: {
                    containerInner: ["select", ...this.selectClasses],
                    listDropdown: this.dropdownClasses,
                    inputCloned: this.hasSearch ? this.searchClasses : [],
                    listSingle: ["h-full", "flex", "items-center", "text-left", sizeClass],
                    listItems: ["h-full", "flex", "flex-wrap", "items-center", "py-1", "gap-x-1.5", "gap-y-1", sizeClass],
                    selectedState: "bg-gray-200",
                    item: ["one", "choices__item"],
                    itemSelectable: ["two", "choices__item--selectable", "flex", "items-center"],
                    itemDisabled: ["three", "choices__item--disabled"],
                    itemChoice: ["four", "choices__item--choice", "dropdown-item", "rounded-input", "hover:bg-gray-200", "h-9", "cursor-pointer"],
                },
                callbackOnCreateTemplates: (strToEl, escapeForTemplate, getClassNames) => {
                    return {
                        item: (data, choice) => {
                            const optionText = choice.label;

                            const isPlaceholder = choice.element.classList.contains("choices-placeholder");

                            const customClasses = choice.element.getAttribute("data-classes") || "";

                            const deleteButton = this.hasMultiple && !isPlaceholder
                                ? `<button class="focus-visible p-1 rounded -mr-[2px] cursor-pointer" aria-label="Remove ${optionText}" data-remove-choice="${choice.value}">
                               <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none">
                                    <g clip-path="url(#icon-${choice.value})">
                                        <path d="M4.72595 4.00002L7.44329 1.28268C7.49233 1.23532 7.53144 1.17867 7.55834 1.11604C7.58525 1.0534 7.59941 0.986037 7.6 0.91787C7.6006 0.849703 7.58761 0.782101 7.56179 0.719008C7.53598 0.655915 7.49786 0.598594 7.44966 0.550391C7.40145 0.502188 7.34413 0.464068 7.28104 0.438254C7.21795 0.412441 7.15035 0.399451 7.08218 0.400044C7.01401 0.400636 6.94665 0.414799 6.88401 0.441704C6.82138 0.46861 6.76473 0.507721 6.71737 0.556755L4.00002 3.2741L1.28268 0.556755C1.18585 0.463238 1.05617 0.411491 0.921565 0.412661C0.786957 0.413831 0.658194 0.467823 0.563008 0.563008C0.467823 0.658194 0.413831 0.786957 0.412661 0.921565C0.411491 1.05617 0.463238 1.18585 0.556755 1.28268L3.2741 4.00002L0.556755 6.71737C0.507721 6.76473 0.46861 6.82138 0.441704 6.88401C0.414799 6.94665 0.400636 7.01401 0.400044 7.08218C0.399451 7.15035 0.412441 7.21795 0.438254 7.28104C0.464068 7.34413 0.502188 7.40145 0.550391 7.44966C0.598594 7.49786 0.655915 7.53598 0.719008 7.56179C0.782101 7.58761 0.849703 7.6006 0.91787 7.6C0.986037 7.59941 1.0534 7.58525 1.11604 7.55834C1.17867 7.53144 1.23532 7.49233 1.28268 7.44329L4.00002 4.72595L6.71737 7.44329C6.81419 7.53681 6.94388 7.58856 7.07848 7.58739C7.21309 7.58622 7.34185 7.53223 7.43704 7.43704C7.53223 7.34185 7.58622 7.21309 7.58739 7.07848C7.58856 6.94388 7.53681 6.81419 7.44329 6.71737L4.72595 4.00002Z" fill="currentColor"/>
                                    </g>
                                    <defs>
                                        <clipPath id="icon-${choice.value}">
                                            <rect width="8" height="8" fill="white"/>
                                        </clipPath>
                                    </defs>
                                </svg>     
                               </button>`
                                : "";

                            return strToEl(`
                            <div class="${customClasses}">
                                ${optionText}
                                ${this.hasDelete ? deleteButton : ""}
                            </div>
                        `);
                        },

                        choice: (classNames, choice) => {

                            const text = choice.label;

                            const customClasses = choice.element.getAttribute("data-classes") || "";

                            const el = strToEl(`
                                <div class="flex py-2 px-2.5 rounded-md hover:bg-gray-200 [&.is-highlighted]:bg-gray-200" data-choice data-id="${choice.id}" data-value="${escapeForTemplate(choice.value)}">
                                    <div class=" ${customClasses}">
                                        ${text}
                                    </div>
                                </div>
            `);

                            if (choice.disabled) {
                                el.setAttribute("data-choice-disabled", "");
                                el.setAttribute("aria-disabled", "true");
                            } else {
                                el.setAttribute("data-choice-selectable", "");
                            }

                            return el;
                        }


                    };
                },
                shouldSort: false,
                silent: false,
            });
            this.initialised = true;
            this.scope._choices = this;

        }


    }
    initChoices() {
        if (this.hasMultiple) {
            this.fixSearch();
            document.addEventListener('click', (e) => {
                const btn = e.target.closest('[data-remove-choice]');
                if (btn) {
                    const value = btn.getAttribute('data-remove-choice');
                    if (value) {
                        this.choices.removeActiveItemsByValue(value);
                    }
                }
            });
            this.choices.passedElement.element.removeAttribute("hidden");
            this.choices.passedElement.element.setAttribute("tabindex", 0);
            this.choices.passedElement.element.classList.add("sr-only");
        }

        const choicesRoot = this.choices.containerOuter.element;

        choicesRoot.removeAttribute("role");
        choicesRoot.removeAttribute("aria-autocomplete");
        choicesRoot.removeAttribute("aria-haspopup");
        choicesRoot.removeAttribute("aria-expanded");

        choicesRoot.querySelector(".choices__list").removeAttribute("role");
    }

    fixSearch() {
        const searchInput = this.choices.input.element;
        if(this.hasSearch){
            const dropdownInner = this.choices.dropdown.element.childNodes;
            this.choices.dropdown.element.appendChild(searchInput);
            dropdownInner.forEach(option =>{
                this.choices.dropdown.element.appendChild(option);
            })
        }else{
            searchInput.remove();
        }
    }

    resetChoice() {
        this.choices.destroy();
        this.scope.selectedIndex = 0;
        this.choices.init();
    }

}

// Initialize ChoicesSelect on all elements with data-choices
document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll(`[data-choices]`).forEach(el => new ChoicesSelect(el));
});
if ('navigation' in window && typeof window.navigation.addEventListener === 'function') {
    window.navigation.addEventListener("navigate", () => {
        setTimeout(() => {
            document.querySelectorAll("[data-choices]").forEach(el => {
                new ChoicesSelect(el);
            });
        }, 60);
    });
}

